import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class ControlCachingService {
  constructor(private cookieService: CookieService) {}

  public handleCaching(hash: string) {
    if (this.cookieService.check('version')) {
      if (hash !== this.cookieService.get('version')) {
        this.cookieService.delete('version', '/');
        this.cookieService.set('version', hash);
        // console.log('Update app from : ' + this.cookieService.get('version') + ' to: ' + hash);
        // Reload the page to update to the latest version
        document.location.reload();
      }
    } else {
      this.cookieService.set('version', hash);
    }
  }
}
